import { Button } from "@/components/ui/button";
import { ArrowLeft, Home } from "lucide-react";
import { Link, useNavigate } from "react-router";
import { useTranslation } from "@/i18n";

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 text-center">
      <div className="max-w-md space-y-6">
        <div className="space-y-2">
          <h1 className="text-4xl font-bold tracking-tight">
            {t("notFound.code")}
          </h1>
          <h2 className="text-2xl font-semibold">{t("notFound.title")}</h2>
          <p className="text-muted-foreground">{t("notFound.description")}</p>
        </div>

        <div className="flex flex-col justify-center gap-2 sm:flex-row">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            {t("common.goBack")}
          </Button>
          <Link to="/">
            <Button className="gap-2">
              <Home className="h-4 w-4" />
              {t("common.home")}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
